import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';

import {PtrnCampoEditableString} from '../../../patronTypes';
import {EditableProps} from '../campoEditableTypes';
import {getNoBorderSx, useInputStyles} from '../campoEditableUtils';
import {PtrnPropsUtil} from '../../../patronUtils';

function CampoEditableString(
   props: {campoConfig: PtrnCampoEditableString} & EditableProps & {
         ErrorComponent?: React.ReactNode;
      }
) {
   const {campoConfig, ...editableProps} = props;
   const auxParam = {
      camposData: editableProps.camposData,
      campoConfig: campoConfig,
      ptrnRef: editableProps.ptrnRef,
      ruta: editableProps.ruta,
      index: editableProps.index
   };

   const classes = useInputStyles();

   const handleOnChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
      const name = e.target.name;
      let newValue = e.target.value;
      editableProps.onChange(name, newValue, auxParam);
   };

   const handleOnBlur: React.FocusEventHandler<HTMLInputElement> = (e) => {
      if (editableProps.onBlur) {
         const name = e.target.name;
         let newValue = e.target.value;
         editableProps.onBlur(name, newValue, auxParam);
      }
   };

   const handleOnFocus: React.FocusEventHandler<HTMLInputElement> = (e) => {
      setTimeout(() => e.target.select(), 0); // Asegura la selección completa del texto
   };
   //#region GEN PROPS
   const id = PtrnPropsUtil.genIdCampoEditable(campoConfig);
   const endAdornments = props.ErrorComponent ? (
      <InputAdornment position="end">{props.ErrorComponent}</InputAdornment>
   ) : undefined;
   //#endregion
   //#region RETORNOS
   return (
      <FormControl fullWidth error={Boolean(props.ErrorComponent)}>
         <InputLabel htmlFor={id}>{campoConfig.label}</InputLabel>
         <OutlinedInput
            sx={getNoBorderSx(campoConfig)}
            className={classes.classes.ceFocused}
            id={id}
            name={campoConfig.name}
            label={campoConfig.label}
            value={editableProps.value || ''}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            onFocus={campoConfig.seleccionarTodo ? handleOnFocus : undefined}
            fullWidth
            endAdornment={endAdornments}
            inputProps={{
               maxLength: campoConfig.maxLength,
               style: {textAlign: campoConfig.alinearTexto || 'left'}
            }}
            type={campoConfig.esPassword ? 'password' : 'text'}
            size="small"
         />
      </FormControl>
   );
   //#endregion
}

export default CampoEditableString;
